import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomCheckbox from '@s-ui/react-atom-checkbox'
import Context from '@s-ui/react-context'
import IconUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import IconChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

export const UnsubscribeEmailsCheckboxForm = ({consents, handleClick}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {EXTERNAL_SERVICES_OFFERS, PORTAL_ANNOUNCEMENTS} = config.get('user').SUBSCRIPTIONS

  const checkboxSectionTitle = i18n.t('UNSUBSCRIBE_EMAILS_PAGE.CHECKBOX_SECTION.TITLE')

  return (
    <>
      <div className="mt-UserUnsubscribeEmails-checkboxSectionTitle">
        <TitleBasic as={titleBasicTags.h5} size={titleBasicSizes.xs} title={checkboxSectionTitle} />
      </div>
      <div className="mt-UserUnsubscribeEmails-checkbox">
        <AtomCheckbox
          id={PORTAL_ANNOUNCEMENTS}
          checked={consents[PORTAL_ANNOUNCEMENTS].value}
          checkedIcon={IconChecked}
          uncheckedIcon={IconUnchecked}
          onChange={e => handleClick({e, id: PORTAL_ANNOUNCEMENTS})}
        />
        <span className="mt-UserUnsubscribeEmails-label">
          {i18n.t('UNSUBSCRIBE_EMAILS_PAGE.CHECKBOX_SECTION.LABEL_1')}
        </span>
      </div>
      <div className="mt-UserUnsubscribeEmails-checkbox">
        <AtomCheckbox
          id={EXTERNAL_SERVICES_OFFERS}
          checked={consents[EXTERNAL_SERVICES_OFFERS].value}
          checkedIcon={IconChecked}
          uncheckedIcon={IconUnchecked}
          onChange={e => handleClick({e, id: EXTERNAL_SERVICES_OFFERS})}
        />
        <span className="mt-UserUnsubscribeEmails-label">
          {i18n.t('UNSUBSCRIBE_EMAILS_PAGE.CHECKBOX_SECTION.LABEL_2')}
        </span>
      </div>
    </>
  )
}

UnsubscribeEmailsCheckboxForm.propTypes = {
  consents: PropTypes.object,
  handleClick: PropTypes.func
}
